import { render, staticRenderFns } from "./resumePart.vue?vue&type=template&id=0239a9ba&scoped=true"
import script from "./resumePart.vue?vue&type=script&lang=js"
export * from "./resumePart.vue?vue&type=script&lang=js"
import style0 from "./resumePart.vue?vue&type=style&index=0&id=0239a9ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0239a9ba",
  null
  
)

export default component.exports